<template>
  <v-expansion-panel light class="elevation-1">
    <v-expansion-panel-content>
      <template v-slot:header>
        <h3>CV</h3>
      </template>
      <div class="px-3 pb-3">
        <v-alert :value="true" type="info">{{ $t('ACCOUNT.CV_INFO') }}</v-alert>
        <v-tabs color="transparent" slider-color="primary">
          <v-tab v-for="lang in langs" :key="lang.label" :ripple="false">{{ lang.label }}</v-tab>
          <v-tab-item touch v-for="lang in langs" :key="lang.key">
            <div class="mt-1">
              <h4>{{ lang.education.title }}</h4>
              <v-textarea
                flat
                box
                solo
                v-model="account.education[lang.key]"
                :error-messages="errors['education.'+lang.key]"
                :placeholder="lang.education.placeholder"
                rows="3"
              />
            </div>
            <div class="mt-3">
              <h4>{{ lang.memberships.title }}</h4>
              <v-textarea
                flat
                box
                solo
                v-model="account.memberships[lang.key]"
                :error-messages="errors['memberships.'+lang.key]"
                :placeholder="lang.memberships.placeholder"
                rows="3"
              />
            </div>
            <div class="mt-3">
              <h4>{{ lang.solo_exhibitions.title }}</h4>
              <v-textarea
                flat
                box
                solo
                v-model="account.solo_exhibitions[lang.key]"
                :error-messages="errors['solo_exhibitions.'+lang.key]"
                :placeholder="lang.solo_exhibitions.placeholder"
                rows="3"
              />
            </div>
            <div class="mt-3">
              <h4>{{ lang.group_exhibitions.title }}</h4>
              <v-textarea
                flat
                box
                solo
                v-model="account.group_exhibitions[lang.key]"
                :error-messages="errors['group_exhibitions.'+lang.key]"
                :placeholder="lang.group_exhibitions.placeholder"
                rows="3"
              />
            </div>
            <div class="mt-3">
              <h4>{{ lang.grants.title }}</h4>
              <v-textarea
                flat
                box
                solo
                v-model="account.grants[lang.key]"
                :error-messages="errors['grants.'+lang.key]"
                :placeholder="lang.grants.placeholder"
                rows="3"
              />
            </div>
            <div class="mt-3">
              <h4>{{lang.residences.title}}</h4>
              <v-textarea
                flat
                box
                solo
                v-model="account.residences[lang.key]"
                :error-messages="errors['residences.'+lang.key]"
                :placeholder="lang.residences.placeholder"
                rows="3"
              />
            </div>
            <div class="mt-3">
              <h4>{{ lang.collections.title}}</h4>
              <v-textarea
                flat
                box
                solo
                v-model="account.collections[lang.key]"
                :error-messages="errors['collections.'+lang.key]"
                :placeholder="lang.collections.placeholder"
                rows="3"
              />
            </div>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: ["account", "errors"],
  data() {
    /*
     * All languages need to loaded. Using i18n doesn't work
     */
    return {
      langs: [
        {
          label: "Finnish",
          key: "fi",
          education: {
            title: "Koulutus",
            placeholder: "Kerro taiteeseen liittyvästä koulutuksestasi"
          },
          memberships: {
            title: "Jäsenyydet",
            placeholder:
              "Kerro missä taiteeseen liittyvissä järjestöissä olet jäsen"
          },
          solo_exhibitions: {
            title: "Yksityisnäyttelyt",
            placeholder: "Yksityisnäyttelyt"
          },
          group_exhibitions: {
            title: "Ryhmä- ja yhteisnäyttelyt",
            placeholder: "Ryhmä- ja yhteisnäyttelyt"
          },
          grants: {
            title: "Apurahat",
            placeholder:
              "Kerro taiteelliseen työhösi varten myönnetyistä apurahoista."
          },
          residences: {
            title: "Residenssit",
            placeholder: "Kerro mahdollisista residenssioleskeluista."
          },
          collections: {
            title: "Kokoelmat",
            placeholder:
              "Minkä yritysten tai organisaatioiden kokoelmissa teoksiasi löytyy?"
          }
        },
        {
          label: "Swedish",
          key: "se",
          education: {
            title: "Utbildning",
            placeholder: "Berätta om din konstnärliga utbildning."
          },
          memberships: {
            title: "Medlemskap",
            placeholder: "Berätta om medlemskap med konstnärlig koppling."
          },
          solo_exhibitions: {
            title: "Soloutställningar",
            placeholder:
              "Berätta om dina soloutställningar: år, utställningens namn, plats osv. Senaste utställningen först."
          },
          group_exhibitions: {
            title: "Grupp- och samutställningar",
            placeholder:
              "Berätta om dina Grupp- och samutställningar: år, utställningens namn, plats osv. Senaste utställningen först."
          },
          grants: {
            title: "Stipendier",
            placeholder:
              "Berätta om beviljade stipendier med konstnärlig koppling"
          },
          residences: {
            title: "Residens",
            placeholder: "Har du vistats vid konstnärsresidens?"
          },
          collections: {
            title: "Samlingar",
            placeholder:
              "Ange företag och organisationer som har din konst i sina samlingar."
          }
        },
        {
          label: "English",
          key: "en",
          education: {
            title: "Education",
            placeholder:
              "Fill in your education with focus on artistic education."
          },
          memberships: {
            title: "Memberships",
            placeholder: "List the relevant organizations you are a member of."
          },
          solo_exhibitions: {
            title: "Solo exhibitions",
            placeholder:
              "List your solo exhibitions: year, name of exhibition, location etc. List your latest exhibition first."
          },
          group_exhibitions: {
            title: "Group exhibitions and collective exhibitions",
            placeholder:
              "List your Group exhibitions and collective exhibitions: year, name of exhibition, location etc. List your latest exhibition first."
          },
          grants: {
            title: "Grants",
            placeholder: "Grants"
          },
          residences: {
            title: "Residences",
            placeholder: "List residences you have attended."
          },
          collections: {
            title: "In collections",
            placeholder:
              "List companies and organizations where your artworks are placed."
          }
        }
      ]
    };
  }
};
</script>

<style scoped>
.lang-selector {
  width: 200px;
}
</style>